// Types d'actions
export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const MARK_ALL_NOTIFICATIONS_READ = 'MARK_ALL_NOTIFICATIONS_READ';
export const RECEIVE_NEW_NOTIFICATION = 'RECEIVE_NEW_NOTIFICATION';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';

// État initial
const initialState = {
  notifications: [],
  loading: false,
  error: null
};

// Reducer
const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload,
        error: null
      };
    
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case MARK_NOTIFICATION_READ:
      return {
        ...state,
        notifications: state.notifications.map(notification => 
          notification.id === action.payload
            ? { ...notification, is_read: true }
            : notification
        )
      };
    
    case MARK_ALL_NOTIFICATIONS_READ:
      return {
        ...state,
        notifications: state.notifications.map(notification => ({
          ...notification,
          is_read: true
        }))
      };
    
    case RECEIVE_NEW_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications]
      };

    case DELETE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(n => n.id !== action.payload)
      };

    default:
      return state;
  }
};

// Actions
export const fetchNotificationsRequest = () => ({
  type: FETCH_NOTIFICATIONS_REQUEST
});

export const fetchNotificationsSuccess = (notifications) => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload: notifications
});

export const fetchNotificationsFailure = (error) => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
  payload: error
});

export const markNotificationRead = (notificationId) => ({
  type: MARK_NOTIFICATION_READ,
  payload: notificationId
});

export const markAllNotificationsRead = () => ({
  type: MARK_ALL_NOTIFICATIONS_READ
});

export const receiveNewNotification = (notification) => ({
  type: RECEIVE_NEW_NOTIFICATION,
  payload: notification
});

export const deleteNotificationAction = (id) => ({
  type: DELETE_NOTIFICATION,
  payload: id
});

// Action creator asynchrone pour récupérer les notifications
export const fetchNotifications = () => async (dispatch, getState, api) => {
  try {
    dispatch(fetchNotificationsRequest());
    
    // Cette API n'existe pas encore dans notre backend, à implémenter
    const response = await api.get('/notifications');
    
    dispatch(fetchNotificationsSuccess(response.data));
  } catch (error) {
    dispatch(fetchNotificationsFailure(
      error.response?.data?.message || 'Une erreur s\'est produite'
    ));
  }
};

export default notificationReducer;